import React, { FC } from "react";

export const TelegramIcon: FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="13" cy="13" r="12.73" fill="#229ED9" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.027 12.868c3.71-1.611 6.18-2.682 7.42-3.201 3.53-1.474 4.27-1.728 4.75-1.739.11 0 .34.021.5.149.13.106.17.244.19.35.02.106.04.329.02.498-.19 2.014-1.02 6.902-1.44 9.149-.18.954-.53 1.272-.87 1.304-.74.064-1.3-.488-2.01-.955-1.12-.731-1.75-1.187-2.84-1.908-1.26-.827-.44-1.282.28-2.024.19-.191 3.45-3.159 3.52-3.424.01-.032.01-.159-.06-.223-.08-.063-.18-.041-.27-.02-.12.021-1.9 1.208-5.37 3.551-.51.35-.97.52-1.38.509-.46-.011-1.33-.255-1.99-.467-.8-.255-1.44-.392-1.39-.837.03-.233.35-.466.94-.71z"
            fill="white"
        />
    </svg>
);